
<app-common-header></app-common-header>
<br />
<br />
<div class="container" >
  <div class="row" >
    <div class="col-md-4">
      <h1>Promo code list</h1>
    </div>
    <div class="col-md-4">
      <mat-form-field style="width: 100%;">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
      </mat-form-field>
    </div>
    <!-- <div class="col-md-3">
    <a (click)="ChangeStatus()"> <img style="cursor: pointer ;margin-top: 6px;width:40px" src="assets/images/sync-flat.svg" /></a>
    </div> -->
 
  <div class="col-md-4 ">
  
  
    <a title="Create Promo code" class="pull-right"(click)="Redirect('')"> <img class="" style="cursor: pointer ;margin-top: 6px;background: #0fd873;  display: inline-block;
      background: #0fd873;
      text-align: center;
      border-radius: 50%;
      width: 38px;
      height: 38px;
      cursor: pointer;" src="assets/images/plus-symbol.svg" /></a>

    <a title="Change Status" style="padding-right: 10px;" class="pull-right" (click)="ChangeStatus(true, 'Active/Inactive')" >  <img class="" style="cursor: pointer ;margin-top: 6px;width:38px" src="assets/images/sync-flat.svg" /></a>
    
    <a  style="padding-right: 10px;" title="Delete" class="pull-right"(click)="ChangeStatus(true,'Delete')"> <img class="" style="cursor: pointer ;margin-top: 6px;background: #ff595e;  display: inline-block;
      background: #ff595e;
      padding: 4px;
      text-align: center;
      border-radius: 50%;
      width: 38px;
      height: 38px;
      cursor: pointer;" src="assets/images/delete.svg" /></a>
        
    <a style="padding-right: 10px;" title="Archived" class="pull-right"(click)="ChangeStatus(true, 'Archive')"> <img class="" style="cursor: pointer ;margin-top: 6px;background: #ffca3a;  display: inline-block;
      background: #ffca3a;
      text-align: center;
      border-radius: 50%;
      padding: 4px;
      width: 38px;
      height: 38px;
      cursor: pointer;" src="assets/images/document.svg" /></a>

      <a style="padding-right: 10px;" title="Suspended" class="pull-right"(click)="ChangeStatus(true, 'Suspend')"> <img class="" style="cursor: pointer ;margin-top: 6px;background: #00baff;  display: inline-block;
        background: #00baff;
        text-align: center;
        border-radius: 50%;
        padding: 4px;
        width: 38px;
        height: 38px;
        cursor: pointer;" src="assets/images/turn-off.svg" /></a>

       <!-- <mat-checkbox class="example-margin"
       [checked]="Activate"
       [color]="task.color"
       [indeterminate]="someComplete()"
       (change)="setAll($event.checked)">

       </mat-checkbox> -->

     
                
        <!-- <a style="padding-right: 10px;" title="Suspend" class="pull-right"(click)="filterTable()"> <img class="" style="cursor: pointer ;margin-top: 6px;background: #00baff;  display: inline-block;
          background: #00baff;
          text-align: center;
          border-radius: 50%;
          padding: 4px;
          width: 38px;
          height: 38px;
          cursor: pointer;" src="assets/images/turn-off.svg" /></a> -->


   <!-- <button
      (click)="Redirect('')"
      class="mt-4 pull-right"
      mat-raised-button
    >
      Create
    </button> -->
  </div>
  <div class="col-md-12">
    <mat-checkbox class="example-margin"
    [checked]="Activate" (change)="StatusChange($event.checked,'Activate')"
     >
     Active
    </mat-checkbox>

    <mat-checkbox class="example-margin" style="padding-left: 20px"
    [checked]="Deactivate" (change)="StatusChange($event.checked,'Deactivate')"
     >
     Deactivated
    </mat-checkbox>

    <mat-checkbox class="example-margin" style="padding-left: 20px"
    [checked]="Archive" (change)="StatusChange($event.checked,'Archive')"
     >
     Archived
    </mat-checkbox>

    <mat-checkbox class="example-margin" style="padding-left: 20px"
    [checked]="Suspend" (change)="StatusChange($event.checked,'Suspend')"
     >
     Suspended
    </mat-checkbox>
  </div>
<div class="col-md-12 card mt-2">
  <div class="table-responsive">
  <table  mat-table [dataSource]="dataSource" matSort>

<!-- Checkbox Column -->
<ng-container matColumnDef="select">
  <th mat-header-cell *matHeaderCellDef>
    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()">
    </mat-checkbox>
  </th>
  <td mat-cell *matCellDef="let row" class="pd-left">
    <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)">
    </mat-checkbox>
  </td>
</ng-container>


     <ng-container matColumnDef="Action">
      <tr>
        <th mat-header-cell *matHeaderCellDef [ngClass]="'w-130'">Action</th>
      </tr>
      <tr>
        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="'w-130'"
          style="width: 5%"
        >
          <button
            mat-icon-button
            color="primary"
            title="Edit Contact"
            (click)="Redirect( element._id )"
            style="width: 30px !important;"
          >
            <mat-icon>edit</mat-icon> 
          </button>
        </td>
      </tr>

      <tr></tr
    ></ng-container>
    <ng-container matColumnDef="Status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="'w-130'">
        Status
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Status }}
      </td>
    </ng-container>
   
    <ng-container matColumnDef="PromoCode">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">Promo code</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.PromoCode }}
      </td>
    </ng-container>

    <ng-container matColumnDef="PromoCodeDescription">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        PromoCode Description
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.PromoCodeDescription }}
      </td>
    </ng-container>

    <ng-container matColumnDef="StartDate">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        Start Date
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.StartDate | date: 'MM/dd/yyyy' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="EndDate">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        End Date
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.EndDate   | date: 'MM/dd/yyyy' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Affiliate">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        Affiliate
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.Affiliate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="AffiliateLink">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        Affiliate Link
      </th>
      <td mat-cell style="padding-left: 20px;" *matCellDef="let element" [ngClass]="'w-130'">
        
        
        <a style="float: left;;" title="Affiliate Link" data-toggle="tooltip" data-placement="top" title="Copied!" class="pull-right"(click)="copyText(element.AffiliateLink)"> <img class="" style="cursor: pointer ;background: #0fd873;  display: inline-block;
          background: #2191fb;
          text-align: center;
          border-radius: 50%;
          width: 32px;
          height: 32px;
          padding: 4px;
        
          cursor: pointer;" src="assets/images/link-icon.svg" /></a>
      </td>
    </ng-container>
    <ng-container matColumnDef="CreatedBy">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        Created By
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.CreatedBy  }} 
      </td>
    </ng-container>
    <ng-container matColumnDef="CreatedDateTime">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">Created Date</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.CreatedDateTime | customDate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="ModifiedBy">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">
        Modified By
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ModifiedBy }} 
      </td>
    </ng-container> 
    <ng-container matColumnDef="ModifiedDateTime">
      <th mat-header-cell *matHeaderCellDef  mat-sort-header [ngClass]="'w-130'">Modified Date</th>
      <td mat-cell *matCellDef="let element" [ngClass]="'w-130'">
        {{ element.ModifiedDateTime | customDate }}
      </td>
    </ng-container>

      <!-- ID Column -->
      

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <!-- <div *ngIf="dataSource.length === 0">No records found</div> -->
  </table>
  </div>
  <!-- <mat-paginator #providerPaginator="matPaginator"
  [pageSizeOptions]="[5, 10, 20]"
  showFirstLastButtons
></mat-paginator> -->
<mat-paginator [pageSizeOptions]="[ 15, 50, 100,1000]" showFirstLastButtons aria-label="Select page of users"></mat-paginator>
</div>
</div>
</div>

<ng-template #StatusModel>
  <div class="modal-header py-0 px-1 pt-1">
    <div class="col-12 text-right py-0 px-0">
      <!-- <button
        type="button"
        class="close pull-right borderNone closeModelAlign"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <div _ngcontent-c5="" class="float-right mr-1 mt-1">
          <img src="assets/images/editchart-close.svg" width="17" />
        </div>
      </button> -->
      <h4
      class="utility-modal-title font20 text-center text-uppercase"
    
    >
    {{title}}
    </h4> 
   
    </div>
  </div>
  <div class="modal-body pt-0" style="text-align: center;">

    <p class="utility-sub-title font20">
    {{msg}}
    </p>
    <button type="button" *ngIf="showChangeStatusButtonInPopup" class="mr-2 mt-0 btn sectbtn brdrRadius "(click)="ChangeStatus()" >Yes, Change Status</button>

    <button type="button"  class="mr-2 mt-0 btn sectbtn brdrRadius "(click)="modalRef.hide()" >{{buttontext}}</button>

  </div>
</ng-template>